export { default as CheckoutCompleteContainer } from './CheckoutCompleteContainer'
export { mapStateToPlaceOrderDetails } from './mapStateToPlaceOrderDetails'


// WEBPACK FOOTER //
// ./src/Components/checkout/Features/PlaceOrder/index.js